const SESSION_KEYS = ["token", "id", "user_id"];

export function clearAuthSession() {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
}

export function storeAuthSession(data) {
  clearAuthSession();

  if (data && typeof data === "object") {
    SESSION_KEYS.forEach((key) => {
      if (data[key] !== undefined && data[key] !== null && data[key] !== "") {
        localStorage.setItem(key, String(data[key]));
      }
    });

    const credential = data.token || data.id || data.user_id;
    if (credential !== undefined && credential !== null && credential !== "") {
      localStorage.setItem("token", String(data.token || credential));
      if (!localStorage.getItem("id") && !localStorage.getItem("user_id")) {
        localStorage.setItem("user_id", String(credential));
      }
    }
    return credential;
  }

  if (data !== undefined && data !== null && data !== "") {
    const credential = String(data);
    localStorage.setItem("id", credential);
    localStorage.setItem("token", credential);
    return credential;
  }

  return "";
}

export function getAuthCredential() {
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("id") ||
    localStorage.getItem("user_id") ||
    ""
  );
}
